import { render } from "./FitnessOverview.vue?vue&type=template&id=45b751b4&scoped=true"
import script from "./FitnessOverview.vue?vue&type=script&lang=js"
export * from "./FitnessOverview.vue?vue&type=script&lang=js"

import "./FitnessOverview.vue?vue&type=style&index=0&id=45b751b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b751b4"]])

export default __exports__